module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"request":{"load_sectors":"Something went wrong while trying to load the sectors.","load_point_of_interests":"Something went wrong while trying to load the points of interest.","load_sector_sets":"Something went wrong while trying to load the regions."}},"ko":{"request":{"load_sectors":null,"load_point_of_interests":null,"load_sector_sets":null}}}')
  delete Component.options._Ctor
}
